import { useRef } from 'react';
import { getLastOrderStatus } from '../queries/collector.graphql.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var POLL_TIMER_MS = 1000;

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var POLL_MAX_TRIES = 15;

function _empty() {}

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var SUCCESS_STATUSES = ["processing", "complete", "payment_review"];
var makeUsePollOrderStatus = client => _ref => {
  function _temp2() {
    if (onError) {
      onError();
    }
  }

  var _ref$successStatuses = _ref.successStatuses,
      successStatuses = _ref$successStatuses === void 0 ? SUCCESS_STATUSES : _ref$successStatuses,
      setProcessing = _ref.setProcessing,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess;
  var timer = useRef();

  var pollOrderStatus = _async(function (numTries) {
    if (numTries === void 0) {
      numTries = POLL_MAX_TRIES;
    }

    function _client() {
      return _await(client(getLastOrderStatus), _temp);
    }

    function _temp(_ref2) {
      var lastOrder = _ref2.lastOrder;

      if (successStatuses.includes((lastOrder == null ? void 0 : lastOrder.status) || "")) {
        if (onSuccess) {
          onSuccess();
        }
      } else if (numTries - 1 === 0) {
        if (setProcessing) {
          setProcessing(false);
        }

        if (onError) {
          onError();
        }
      } else {
        timer.current = setTimeout(() => {
          timer.current = null;
          pollOrderStatus(numTries - 1);
        }, POLL_TIMER_MS);
      }
    }

    return _invokeIgnored(function () {
      if (!timer.current) {
        if (setProcessing) {
          setProcessing(true);
        }

        timer.current = true; // Set to true, to prevent possible race-condition

        return _continueIgnored(_catch(_client, _temp2));
      }
    });
  });

  return pollOrderStatus;
};

export { SUCCESS_STATUSES, makeUsePollOrderStatus };
//# sourceMappingURL=use-poll-order-status.js.map
